import { useEffect, useState } from "react";
import { CONTACT } from "../../config";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { useLenisLock } from "../../lib/useLenisLock";
import { Loader2 } from "lucide-react";

export const BookingModal = ({ open, onOpenChange }) => {
  const [loaded, setLoaded] = useState(false);
  useLenisLock(open);

  useEffect(() => {
    if (open) setLoaded(false);
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="booking-modal"
        className="max-w-3xl w-[95vw] h-[85vh] p-0 bg-white border-white/10 overflow-hidden flex flex-col gap-0"
      >
        <DialogHeader className="px-6 pt-5 pb-4 border-b border-white/10 shrink-0 bg-[#0b0b0f] space-y-0">
          <DialogTitle className="font-display text-xl text-white">Agenda tu llamada</DialogTitle>
          <DialogDescription className="sr-only">
            Selecciona una fecha y hora disponible para tu llamada de diagnóstico.
          </DialogDescription>
        </DialogHeader>
        <div className="relative flex-1 bg-white overflow-hidden">
          {!loaded && (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-zinc-500 pointer-events-none" data-testid="calendly-loading">
              <Loader2 size={28} className="animate-spin text-[var(--magenta)]" />
              <span className="text-sm">Cargando calendario…</span>
            </div>
          )}
          {open && (
            <iframe
              title="Agenda GHL"
              src={CONTACT.booking}
              onLoad={() => setLoaded(true)}
              scrolling="yes"
              allow="payment"
              className="w-full h-full border-0"
              data-testid="calendly-iframe"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
